import { Navigate, Route } from "react-router-dom";
import DocsSection from "../../../components/docs/DocsSection";
import { DOC_NAV } from "./docNav.config";
import { DOCS_DEFAULT_PATH, DOCS_DEFAULT_ROUTE } from "./docConstants";

/**
 * Section routes rendered inside DocsPage <Routes>.
 * Parent App route is /docs/* — these match the remaining path segment(s).
 */
export function renderDocsSectionRoutes(docNav = DOC_NAV) {
  const sectionRoutes = docNav.flatMap((group) =>
    group.items.map((item) => (
      <Route
        key={item.id}
        path={item.route}
        element={<DocsSection sectionId={item.id} docNav={docNav} />}
      />
    )),
  );

  return (
    <>
      <Route index element={<Navigate to={DOCS_DEFAULT_ROUTE} replace />} />
      {sectionRoutes}
      <Route path="*" element={<Navigate to={DOCS_DEFAULT_PATH} replace />} />
    </>
  );
}
